export default (id) => {
  if (id === 20) return 'HMI'
}